module.exports = __webpack_public_path__ + "static/media/2.54a59ccd.jpg";